export default __webpack_public_path__ + "static/media/img_17.10faab8a.jpg";